import { useMutation, useQueryClient } from 'react-query';
import request from '../../../../../../helpers/request';
import { getQueryKeys } from '../../../../shared/lib/getQueryKeys';
import useGetParamsForRequest from '../../../../shared/hooks/useGetParamsForRequest';
import useAddAttachmentsNote from './useAddAttachmentsNote';
import useDeleteAttachmentsNote from './useDeleteAttachmentsNote';

const updateComment = async ({ id, comment }) => {
  return await request.put(
    `/Access/transport/note/${id}`,
    {
      comment,
      availableForClient: true,
    },
    'При изменении комментария произошла ошибка',
    'Error'
  );
};

const useEditComment = () => {
  const queryClient = useQueryClient();

  const paramsRequestPermits = useGetParamsForRequest();

  const { mutateAsync: addAttach } = useAddAttachmentsNote();
  const { mutateAsync: deleteAttach } = useDeleteAttachmentsNote();

  const editComment = async ({
    id,
    comment,
    attachments,
    removedAttachmentIds,
  }) => {
    const data = await updateComment({ id, comment });

    if (data === 'Error') return data;

    const requests = [];

    if (!!attachments?.length) {
      requests.push(addAttach({ id, files: attachments }));
    }

    if (!!removedAttachmentIds?.length) {
      requests.push(deleteAttach({ ids: removedAttachmentIds }));
    }

    await Promise.all(requests);

    return data;
  };

  return useMutation(editComment, {
    onSuccess: () => {
      queryClient.refetchQueries(getQueryKeys.permits(paramsRequestPermits));
    },
  });
};

export default useEditComment;
